import Main from '@/pages/main'
import Home from '@/pages/home'
import Product from '@/pages/product'
import ProductBox from '@/pages/product-box'
import ProductPile from '@/pages/product-pile'
import ProductPile1 from '@/pages/product-pile1'
import Solution from '@/pages/solution'
import Download from '@/pages/download'
import AboutUs from '@/pages/aboutus'
import Guide from '@/pages/guide'
import ServiceSupport from '@/pages/service-support'
// 移动端
import MbMain from '@/pages/mobile/mb-main'
import MbHome from '@/pages/mobile/mb-home'
import MbProduct from '@/pages/mobile/mb-product'
import MbProductBox from '@/pages/mobile/mb-product-box'
import MbProductPile from '@/pages/mobile/mb-product-pile'
import MbSolution from '@/pages/mobile/mb-solution'
import MbDownload from '@/pages/mobile/mb-download'
import MbAboutus from '@/pages/mobile/mb-aboutus'
import MbGuide from '@/pages/mobile/mb-guide'
import MbServiceSupport from '@/pages/mobile/mb-service-support'
import MbProductPile1 from '@/pages/mobile/mb-product-pile1'

const getRdHome = () => {
  const userAgentInfo = navigator.userAgent
  const Agents = ['Android', 'iPhone', 'iPad']
  let flag = true
  for (let v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false
      break
    }
  }
  if (flag) {
    return '/home'
  } else {
    return '/mhome'
  }
}

const routers = [
  {
    path: '/main',
    name: 'main',
    component: Main,
    children: [
      {
        path: '/home',
        name: 'home',
        component: Home
      },
      {
        path: '/product',
        name: 'product',
        component: Product
      },
      {
        path: '/product/box',
        name: 'productBox',
        component: ProductBox
      },
      {
        path: '/product/pile',
        name: 'productPile',
        component: ProductPile
      },
      {
        path: '/product/pile1',
        name: 'productPile1',
        component: ProductPile1
      },
      {
        path: '/solution',
        name: 'solution',
        component: Solution
      },
      {
        path: '/download',
        name: 'download',
        component: Download
      },
      {
        path: '/aboutus',
        name: 'aboutus',
        component: AboutUs
      },
      {
        path: '/guide',
        name: 'guide',
        component: Guide
      },
      {
        path: '/serviceSupport',
        name: 'serviceSupport',
        component: ServiceSupport
      }
    ]
  },
  {
    path: '/mbMain',
    name: 'mbMain',
    component: MbMain,
    children: [
      {
        path: '/mhome',
        name: 'mhome',
        component: MbHome
      },
      {
        path: '/mproduct',
        name: 'mproduct',
        component: MbProduct
      },
      {
        path: '/mproduct/box',
        name: 'mProductBox',
        component: MbProductBox
      },
      {
        path: '/mproduct/pile',
        name: 'mProductPile',
        component: MbProductPile
      },
      {
        path: '/mproduct/pile1',
        name: 'mProductPile1',
        component: MbProductPile1
      },
      {
        path: '/msolution',
        name: 'msolution',
        component: MbSolution
      },
      {
        path: '/mdownload',
        name: 'mdownload',
        component: MbDownload
      },
      {
        path: '/maboutus',
        name: 'maboutus',
        component: MbAboutus
      },
      {
        path: '/mguide',
        name: 'mguide',
        component: MbGuide
      },
      {
        path: '/mserviceSupport',
        name: 'mServiceSupport',
        component: MbServiceSupport
      }
    ]
  },
  {
    path: '**',
    redirect: getRdHome()
  }
]
export default routers
